import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgResalat = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#resalat_svg__a)'>
      <path
        fill='#009AAE'
        d='M12.962 1.14A3.42 3.42 0 0 1 14.898 0c-.244.234-.543.46-.583.824-.1.571.328 1.04.707 1.405 1.432 1.435 2.855 2.88 4.29 4.312.437.43.852.9 1.104 1.466.293.628.417 1.368.199 2.04-.201.734-.834 1.347-1.598 1.459-.546.116-1.098-.03-1.617-.194-.454-.15-.97-.163-1.4.065-.52.26-.917.698-1.334 1.087L9.22 17.959c-.893.904-1.847 1.798-3.026 2.31a6.1 6.1 0 0 1-2.346.52c.241.435.537.89 1.03 1.06.684.226 1.418.032 2.056-.25 1.26-.608 2.351-1.52 3.322-2.518q2.418-2.42 4.843-4.837c.724-.759 1.64-1.451 2.722-1.514 1.407-.14 2.796.888 3.153 2.245-.264-.258-.584-.502-.974-.485-.65 0-1.154.47-1.571.92-2.039 2.03-4.05 4.088-6.1 6.108.25.231.56.427.91.429.562.052 1.076-.27 1.455-.657q1.85-1.872 3.706-3.735c.473-.475.93-.983 1.515-1.321.543-.325 1.193-.537 1.834-.419 1.179.23 2.108 1.322 2.251 2.5-.2-.217-.396-.49-.714-.521-.5-.084-.917.25-1.25.578q-2.36 2.354-4.71 4.718c-1.12 1.072-3.001 1.17-4.234.231a2.9 2.9 0 0 1-1.025-1.52c-.966.967-2.161 1.741-3.502 2.043-1.145.293-2.409.183-3.45-.393s-1.771-1.615-2.075-2.747c-.923-.216-1.786-.733-2.33-1.524-.652-.952-.85-2.18-.615-3.304.217-1.16.788-2.222 1.486-3.16.144-.185.271-.396.479-.517.32-.46.73-.929 1.304-1.05a1.95 1.95 0 0 1 1.496.204c-.271-.485-.369-1.08-.166-1.608a1.94 1.94 0 0 1 1.393-1.266c.432-.06.902-.066 1.29.162.834.397 1.276 1.461.965 2.335a1.97 1.97 0 0 1-1.686 1.323c-.385.046-.754-.095-1.1-.25.24.478.292 1.03.144 1.545a1.96 1.96 0 0 1-1.25 1.255c-.558.167-1.198.09-1.673-.257a1.9 1.9 0 0 1-.822-1.556c-.02-.25.083-.486.096-.732l-.07.01c-.823 1.162-1.564 2.46-1.707 3.906-.075.73.214 1.557.894 1.91.667.412 1.501.312 2.207.052 1.057-.406 1.995-1.075 2.824-1.84q2.939-2.952 5.874-5.906c.811-.787 1.957-1.309 3.101-1.117.834.098 1.44.741 2.146 1.13.266.12.605.308.876.102.13-.073.094-.24.083-.364-.124-.418-.433-.743-.732-1.046q-2-2.009-4.01-4.01c-.546-.542-1-1.21-1.162-1.973-.138-.722.117-1.475.584-2.025z'
      />
    </g>
    <defs>
      <clipPath id='resalat_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgResalat)
export default ForwardRef
